<template>
  <div>
    <ul>
      <li>
        <div class="icon-side-menu" @click="toggleMenu()">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </li>
      <li v-if="$store.state.auth.typeOfUser !== 'pharmacy'" :class="{'active': subIsActive(['/'])}" @click="onOpenOtpInput()">
          <router-link to="/" class="icon-onetime">
            <span class="side-txt">{{ $t('otp_input') }}</span>
          </router-link>
      </li>
      <li :class="{'active': subIsActive(['/patient'])}" v-if="patientHistoriesFlg !== 1" @click="checkPatientHistoriesFlg">
        <a href="javascript:;" class="icon-patient">
          <span class="side-txt">{{ $t('patient_information') }}</span>
        </a>
      </li>
      <li :class="{'active': subIsActive(['/patients'])}" v-else @click="checkPatientHistoriesFlg">
        <a href="javascript:;" class="icon-patients">
          <span class="side-txt">{{ $t('patient_list') }}</span>
        </a>
      </li>
      <li :class="{'active': subIsActive(['/notifications'])}">
        <router-link to="/notifications" class="icon-news">
          <span class="side-txt">{{ $t('notification') }}<span class="s-date-txt">{{ $t('update', { lastUpdate: lastUpdate }) }}</span></span>
        </router-link>
      </li>
      <li v-if="$store.state.auth.doctorInfo.region_id" :class="{'active': subIsActive(['/notifications/region'])}">
        <router-link to="/notifications/region" class="icon-news-for-osaka">
          <span class="side-txt">{{ $t('information_osaka_prefecture_special') }}</span>
          <span v-if="$store.state.notification.viewed_flg" class="notification-circle-icon">!</span>
        </router-link>
      </li>
      <li :class="{'active': subIsActive(['/contact-form', '/contact-confirm', '/contact-finished'])}">
        <router-link to="/contact-form" class="icon-contact">
          <span class="side-txt">{{ $t('contact') }}</span>
        </router-link>
      </li>
      <li 
        v-if="$store.state.auth.doctorInfo.region_id && parseInt($store.state.auth.doctorInfo.region_authority) == 1" 
        :class="{'active': subIsActive(['/notifications/management'])}">
        <router-link to="/notifications/management" class="icon-news-management">
          <span class="side-txt">{{ $t('notification_management') }}</span>
        </router-link>
      </li>
      <li v-if="$store.state.auth.typeOfUser !== 'pharmacy'" :class="{'active': subIsActive(['/settings', '/change-email', '/confirm-change-email'])}">
        <router-link to="/settings" class="icon-setting">
          <span class="side-txt">{{ $t('configuration') }}</span>
        </router-link>
      </li>
      <li><a href="javascript:;" @click="$bvModal.show('modal-logout')" class="icon-logout"><span class="side-txt">{{ $t('log_out') }}</span></a></li>
    </ul>
    <b-modal id="modal-logout" class="modal-content center" :hide-header="true" :hide-footer="true" style="width:60%; top: 50%">
      <div class="modal-inner">
        <p class="modal-ttl">{{ $t('log_out') }}</p>
        <p class="center mb40">{{ $t('do_you_want_to_log_out') }}</p>
        <div class="modal-btn-area clearfix">
          <div class="btn-base pos-left"><a href="javascript:;" @click="onLogout()"><p>{{ $t('ok') }}</p></a></div>
          <div class="btn-cancel pos-right"><a href="javascript:;" @click="$bvModal.hide('modal-logout')" class="modal-close"><p>{{ $t('cancel') }}</p></a></div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { BModal, VBModal, BButton} from 'bootstrap-vue'
  import { mapState, mapGetters } from "vuex"
  import OTP from '../components/OTP/Otp.vue'
  import firebase from "firebase/app"
  import 'firebase/messaging'
  export default {
    directives: { BModal, VBModal, BButton },
    data() {
      return {
      }
    },
    components: {
      BModal,
      VBModal,
      BButton,
      OTP
    },
    watch: {
      async doctorInfo() {
        if(
          !this.$store.state.notification.viewed_flg &&
          this.doctorInfo.region_id
        ) {
          await this.$store.dispatch('notification/getNotifications', 'region')
        }
      }
    },
    computed: {
      ...mapState({
        doctorInfo: state => state.auth.doctorInfo
      }),
      ...mapGetters({
        patientHistoriesFlg: 'auth/patientHistoriesFlg'
      }),
      lastUpdate() {
        if (this.$store.state.notification.lastUpdate) {
          const date = this.$store.state.notification.lastUpdate.split(' ')[0]
          const [year, month, day] = date.split('/')
          return month + '/' + day
        }
      }
    },
    methods: {
      onLogout() {
        this.$store.dispatch('otp/initLogout')
        this.$store.dispatch('auth/logout')
        window.localStorage.setItem('isLogout', true)
        this.$router.push('/login')
      },
      toggleMenu() {
        let ml_w = document.getElementById('m-left-col')
        let mr_w = document.getElementById('m-right-col')
        let st = document.getElementsByClassName('side-txt')
        let navWidth = this.$t('__locale') == 'en' ? 250 : 240
        if(ml_w.offsetWidth === navWidth) {
            document.getElementsByClassName('icon-news-for-osaka')[0]?.setAttribute('style','display: initial')
            ml_w.style.width = '60px'
            mr_w.style.width = 'calc(100% - 60px)'
            mr_w.style.marginLeft = '60px'
            Array.from(st).forEach(function(item) {
              item.style.display = 'none'
            })
        } else {
            document.getElementsByClassName('icon-news-for-osaka')[0]?.setAttribute('style','display: inline-flex')
            ml_w.style.width = navWidth+'px'
            mr_w.style.width = 'calc(100% - '+navWidth+'px)'
            mr_w.style.marginLeft = navWidth+'px'
            Array.from(st).forEach(function(item) {
              item.style.display = 'inline'
            })
        }
      },
      subIsActive(paths) {
        return paths.some(path => {
          return this.$route.path === path
        })
      },
      onOpenOtpInput() {
        const isSafari = /.*Version.*Safari.*/.test(navigator.userAgent)
        if (!isSafari && ('Notification' in window) && Notification.permission !== "denied") {
          Notification.requestPermission().then(permission => {
            if (permission === "granted") {
              const messaging = firebase.messaging()
              messaging
              .getToken()
              .then(currentToken => {
                  if (currentToken) {
                    this.$store.dispatch("auth/setFcmToken", currentToken)
                  } else {
                    console.error(this.$t('no_instance_id_token_available_request_permission_to_generate_one'))
                  }
                })
                .catch(err => {
                    console.log(this.$t('an_error_occurred_while_retrieving_token'), err)
                })
              }
            })
          }
      },
      async checkPatientHistoriesFlg() {
        if (this.$store.state.auth.typeOfUser === 'pharmacy') {
          this.$router.push('/patients').catch(()=>{})
        }
        else {
          await this.$store.dispatch('auth/getDoctorInfo')
          if (this.patientHistoriesFlg === 1) {
            this.$router.push('/patients').catch(()=>{})
          } else {
            this.$router.push('/patient').catch(()=>{})
          }
        }
      }
    },
    async mounted() {
      if (
        !this.$store.state.notification.viewed_flg &&
        this.doctorInfo.region_id
      ) {
        await this.$store.dispatch('notification/getNotifications', 'region')
      }
      if (!this.$store.state.notification.lastUpdate) {
        await this.$store.dispatch('notification/getNotifications')
      }
    }
  }
</script>
<style scoped>
  .notification-circle-icon {
    background-color: red;
    width: 16px;
    height: 16px;
    border-radius: 16px;
    line-height: 16px;
    font-size: 12px;
    text-align: center;
    margin: auto 0px;
  }
  .icon-news-for-osaka {
    display: flex;
  }
</style>